// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__34QOX","cardHeader":"styles_cardHeader__1Aknk","buttons":"styles_buttons__1vmB3"};